module.exports = require('./helpers/bundle-url').getBundleURL('jl8RY') + "logo.c51670a8.svg";